<div #wrapper class="shopping-list-wrapper">
    <app-modal-header [text]="'shopping_list' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container>
        <div class="row" style="padding: 9px 22px;">
            <div class="col-12 stretch-card">
                <div class="col-6 no-padding" style="padding-right: 10px !important;">
                    {{ 'from' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onStartDateChange($event)"
                            [(ngModel)]="fromDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
                <div class="col-6 no-padding" style="padding-left: 10px !important;">
                    {{ 'to' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onToDateChange($event)"
                            [(ngModel)]="toDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
            </div>
        </div>

        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <div class="row" style="margin: 10px 0;">
                <div class="col-6 text-left">
<!--                    Стойност на пазарската количка: <span class="total-price">{{ calculateTotal() }}</span>-->
                </div>
                <div class="col-6 text-right no-padding">
                    <button
                            (click)="openFriendsModal()"
                            class="btn btn-sm btn-info">
                        <i class="fa fa-users"></i>
                        + {{ 'friends' | localise }}
                        <span *ngIf="friends.length > 0">({{ friends.length }})</span>
                    </button>
                </div>
            </div>

            <ng-container *ngFor="let category of categories">
                <h2 class="shopping-list-title">{{ category.title }}</h2>

                <div class="list-wrapper shopping-list">
                    <ul class="todo-list todo-list-custom">
                        <ng-container *ngFor="let item of shoppingItems; let i = index">
                            <li
                                    *ngIf="item.category && item.category.id === category.id"
                                    [ngClass]="{'completed' : item.completed }">
                                <div class="form-check form-check-flat" style="display: flex;">
                                    <ng-container *ngIf="item.images.length > 0">
                                        <div
                                                [ngStyle]="{'background': 'url(\''+constants.imagesUrl() + '/images/100x100/' + item.images[0].type + '/' + item.images[0].name + '/'+'\') center center no-repeat', 'background-size': 'contain'}"
                                                style="width: 36px;height: 36px; margin-left: 30px; margin-top: -6px;"></div>
                                    </ng-container>

<!--                                    <div class="price" *ngIf="item.price != null">-->
<!--                                        {{ item.price }}-->
<!--                                    </div>-->

                                    <label class="form-check-label"
                                           [ngStyle]="{'marginTop': (item.images.length <= 0 ? '1px' : '3px'), 'marginLeft': (item.images.length <= 0 ? '29px' : '9px')}"
                                           style="width: 82%;">
                                        <input class="checkbox"
                                               type="checkbox"
                                               [checked]="item.completed"
                                               (change)="changeShoppingItemStatus($event, i)">

                                        {{item.task}} - {{ item.weight }}

                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>

                <div class="clear"></div>
            </ng-container>

            <!-- EXTERNAL MEALS -->
            <h2 class="shopping-list-title">{{ 'external_meals' | localise }}</h2>

            <div class="list-wrapper shopping-list">
                <ul class="todo-list todo-list-custom">
                    <ng-container *ngFor="let item of shoppingItems; let i = index">
                        <li
                                *ngIf="!item.category"
                                [ngClass]="{'completed' : item.completed }">
                            <div class="form-check form-check-flat" style="display: flex;">
                                <label class="form-check-label"
                                       [ngStyle]="{'marginTop': (item.images.length <= 0 ? '1px' : '3px'), 'marginLeft': (item.images.length <= 0 ? '29px' : '9px')}"
                                       style="width: 82%;">
                                    <input class="checkbox"
                                           type="checkbox"
                                           [checked]="item.completed"
                                           (change)="changeShoppingItemStatus($event, i)">

                                    {{item.task}} - {{ item.weight }}
                                    <i class="input-helper"></i>
                                </label>
                            </div>
                        </li>
                    </ng-container>

                </ul>
            </div>

            <div class="clear"></div>
        </div>

        <div class="modal-footer shopping-list-modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
<!--            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>-->
            <button type="button" class="btn btn-sm btn-secondary"
                    (click)="openSendToFriendModal()">
                <i class="fa fa-send"></i>&nbsp;
                {{ 'send_to_friend_btn' | localise }}
            </button>

            <button *ngIf="showVmvButton" type="button" class="btn btn-primary btn-vmv"
                    (click)="openVmvModal()">
                <img src="/assets/images/vmv_logo_small.png" />
                Направи поръчка
            </button>

            <!--            <button type="button" class="btn btn-success"-->
            <!--                    (click)="reload()">-->
            <!--                <i class="fa fa-refresh"></i>&nbsp;-->
            <!--                {{ 'reload' | localise }}-->
            <!--            </button>-->
        </div>
    </ng-container>
</div>
